// Team display names → LAST NAMES ONLY, everywhere a team is shown (bracket,
// leaderboard, scorecard, TV boards, pairings, …).
//
//   "Grant Anderson / Kyle Smith" → "Anderson / Smith"
//   "Smith / Jones"               → "Smith / Jones"   (already last-only)
//   "Mary Van Dyke / J. Roe"      → "Dyke / Roe"
//
// This is PURELY a display transform — the stored team name (used for the
// normalizeTeamKey matching in the build + /play flow) is never changed.
//
// Safety: only strings that contain "/" (i.e. an actual two-player team name)
// are transformed. Anything without a slash — event titles, single labels,
// placeholders like "W1"/"TBD" — is returned untouched, so this can be applied
// liberally at any team-name render site without mangling non-team text.

const SUFFIX = /^(jr|sr|ii|iii|iv|v)\.?$/i

function lastToken(seg) {
  const t = String(seg).trim().split(/\s+/).filter(Boolean)
  if (t.length <= 1) return String(seg).trim()
  const i = t.length - 1
  // Keep a trailing generational suffix with the surname: "Smith Jr".
  if (SUFFIX.test(t[i]) && t.length >= 3) return `${t[i - 1]} ${t[i]}`
  return t[i]
}

export function lastNames(name) {
  if (name == null) return name
  const s = String(name)
  if (!s.includes('/')) return name
  return s.split('/').map(lastToken).join(' / ')
}
